import { inject, provide, ref } from '@vue/composition-api';

export const createSnackBar = () => {
  const showed = ref(false);
  const text = ref('');
  const options = ref({});

  const defaultOptions = {
    timeout: 3000
  };

  const show = (message, options = defaultOptions) => {
    showed.value = true;
    options.value = {
      ...defaultOptions,
      ...options
    };
    text.value = message;
  };

  const error = message => {
    showed.value = true;
    options.value = {
      ...defaultOptions,
      color: 'red'
    };
    text.value = message;
  };

  const hide = () => {
    showed.value = false;
    text.value = '';
    options.value = {};
  };
  return {
    show,
    hide,
    options,
    text,
    showed,
    error
  };
};

export const SnackBarProviderSymbol = Symbol('Snackbar identifier');

export const useSnackBarProvider = () => {
  provide(SnackBarProviderSymbol, createSnackBar());
};

export function useSnackBar() {
  return inject(SnackBarProviderSymbol);
}
